import { ContentContext } from "../../../../utils/contexts";

import {  Visibility, StarBorder  } from "@mui/icons-material";
import {
	ListItemText,
	ListItemIcon,
	Button,
	Popover,
	MenuList,
	MenuItem,
 } from "@mui/material";

import { filters } from "../../../../constants";

class Filters extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			anchor: null,
		};
	}

	handleDropDownClick = event => {
		this.setState({ anchor: event.currentTarget });
	};

	closeMenu = () => {
		this.setState(() => ({ anchor: null }));
	};

	onFilterClick = name => {
		const { fetchChildrenByFilter, fetchContent, fetchTreeChildren, setProperty } = this.context;

		setProperty("filter", name || null);

		if (!name) {
			fetchContent();
			fetchTreeChildren();
		} else {
			fetchChildrenByFilter(name);
		}

		this.closeMenu();
	};

	getIcon = name => {
		switch (name) {
			case 'editingMe': return 'edit';
			case 'editingOthers': return 'user-edit';
			case 'recentlyAdded':
			case 'recentlyModified': return 'clock';
			case 'favourites': return 'star';
			default: return '';
		}
	};

	render() {
		const { filter, loadingContent } = this.context;
		const filterSelected = filter && filter !== 'favourites';
		const favouritesSelected = filter === 'favourites';

		const baseButtonSx = {
			padding: '0.5rem',
			minWidth: 0,
		};

		return (
			<div>
				<Button
					variant="outlined"
					disabled={loadingContent}
					onClick={filterSelected ? () => this.onFilterClick(null) : this.handleDropDownClick}
					sx={{
						...baseButtonSx,
						...(filterSelected && {
							backgroundColor: '#ff9a00 !important',
						}),
					}}
					id="filtersDropdownBtn"
				>
					<Visibility color={filterSelected ? 'secondary' : 'inherit'} fontSize="small" />
				</Button>

				<Popover
					open={this.state.anchor !== null}
					anchorEl={this.state.anchor}
					onClose={this.closeMenu}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					<MenuList>
						{filters
							.filter(item => item !== 'favourites')
							.map(item => (
								<MenuItem
									key={item}
									onClick={() => this.onFilterClick(item)}
									selected={filter === item}
									id={item}
								>
									<ListItemIcon>
										<i className={`fas fa-${this.getIcon(item)}`} />
									</ListItemIcon>
									<ListItemText
										primary={window.Alfresco.messages.global[`edocat.document-library.filters.${item}.title`]}
									/>
								</MenuItem>
							))}
					</MenuList>
				</Popover>

				<Button
					variant="outlined"
					disabled={loadingContent}
					onClick={() => this.onFilterClick(favouritesSelected ? null : 'favourites')}
					sx={{
						...baseButtonSx,
						...(favouritesSelected && {
							backgroundColor: '#ff9a00 !important',
						}),
					}}
					id="favouritesBtn"
				>
					<StarBorder color={favouritesSelected ? 'secondary' : 'inherit'} fontSize="small" />
				</Button>
			</div>
		);
	}
}

Filters.contextType = ContentContext;

export default Filters;
